module.exports = __webpack_public_path__ + "img/price-settings-desktop-ru.5c261a13.jpg";